import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createObj, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, append, delay, toList, iterate } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { toArray } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export class CheckboxState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Checked", "NotChecked", "Indeterminate"];
    }
}

export function CheckboxState_$reflection() {
    return union_type("Shopfoo.Client.Components.CheckboxState", [], CheckboxState, () => [[], [], []]);
}

export function CheckboxState_CheckedIf_Z1FBCCD16(condition) {
    if (condition) {
        return new CheckboxState(0, []);
    }
    else {
        return new CheckboxState(1, []);
    }
}

export function CheckboxState__get_IsChecked$0027(this$) {
    return equals(this$, new CheckboxState(0, []));
}

export function CheckboxState__Toggle(this$) {
    switch (this$.tag) {
        case 1:
            return new CheckboxState(0, []);
        case 2:
            return new CheckboxState(0, []);
        default:
            return new CheckboxState(1, []);
    }
}

export function Checkbox_Checkbox_Z1659CCBA(checkbox_Checkbox_Z1659CCBAInputProps) {
    let value_2, elems;
    const onCheck = checkbox_Checkbox_Z1659CCBAInputProps.onCheck;
    const children = checkbox_Checkbox_Z1659CCBAInputProps.children;
    const state = checkbox_Checkbox_Z1659CCBAInputProps.state;
    const key = checkbox_Checkbox_Z1659CCBAInputProps.$key;
    const checkboxRef = reactApi.useRef(undefined);
    const toggleState = () => {
        onCheck(CheckboxState__get_IsChecked$0027(CheckboxState__Toggle(state)));
    };
    const dependencies = [state];
    reactApi.useEffect(() => {
        iterate((input) => {
            input.indeterminate = equals(state, new CheckboxState(2, []));
        }, toArray(checkboxRef.current));
    }, dependencies);
    return createElement("label", createObj(ofArray([["key", `${key}-label`], (value_2 = "cursor-pointer flex items-center gap-0 p-2 text-sm w-full focus-within:ring-2 focus-within:ring-accent", ["className", value_2]), ["tabIndex", -1], ["onMouseDown", (_arg) => {
        _arg.preventDefault();
    }], ["onClick", (ev) => {
        ev.preventDefault();
        toggleState();
    }], (elems = toList(delay(() => append(singleton(createElement("input", createObj(Helpers_combineClasses("checkbox", ofArray([["type", "checkbox"], ["className", "mr-2"], ["style", {
        "--size": "1.25rem",
    }], ["ref", checkboxRef], ["key", `${key}-checkbox`], ["checked", CheckboxState__get_IsChecked$0027(state)], ["onChange", (ev_1) => {
        const _arg_1 = ev_1.target.checked;
        toggleState();
    }], ["onClick", (_arg_2) => {
        _arg_2.stopPropagation();
    }]]))))), delay(() => children)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

